import { SHOW_CATEGORY_DETAILS } from 'actionTypes/categoryDetailsActionTypes';

export const setCategoryDetails = (payload) => ({
  type: SHOW_CATEGORY_DETAILS,
  payload,
});
export default {
  setCategoryDetails,
};
